const phoneType = {
  landLine: '陆线',
  mobile: '移动',
  fax: '传真',
};

export default phoneType;
